import React from "react";
import { ArrowUpRight } from "lucide-react";
import { trackAffiliateClick } from "../lib/analytics";

const AffiliateButton = ({ href, children, variant = "primary", testId, className = "", trackLocation = "" }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 font-semibold text-sm md:text-base tracking-wide transition-all duration-300 shadow-md hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-offset-2";
  const variants = {
    primary: "btn-primary-gradient text-white focus:ring-[#FF8C00]",
    navy: "bg-[#0B2C5B] text-white hover:bg-[#0B2C5B]/90 focus:ring-[#0B2C5B]",
    outline:
      "border-2 border-[#0B2C5B] text-[#0B2C5B] bg-white/60 hover:bg-[#0B2C5B] hover:text-white focus:ring-[#0B2C5B]",
    light: "bg-white text-[#0B2C5B] hover:bg-[#FFF7E8] focus:ring-white",
  };
  const labelText = typeof children === "string" ? children : (testId || "affiliate");
  const category = /experience|activit|getyourguide|gyg/i.test(href || "")
    ? "experience"
    : /train|transport/i.test(labelText)
    ? "transport"
    : "hotel";
  const onClick = () => {
    trackAffiliateClick({
      label: labelText,
      category,
      destination: href,
      location: trackLocation || testId,
    });
  };
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid={testId}
      onClick={onClick}
      className={`${base} ${variants[variant]} ${className}`}
    >
      <span>{children}</span>
      <ArrowUpRight className="w-4 h-4" />
    </a>
  );
};

export default AffiliateButton;
